import { Factory } from 'rosie';

Factory.define('CustomerMatch').attr('name', 'CUSTOMER_MATCH');

Factory.define('CustomerMatchWithDefaults')
  .extend('CustomerMatch')
  .attr('profiles', []);



// WEBPACK FOOTER //
// ./factories/customer_match_factory.js